  'use-strict'

export default class {
  constructor() {
    window.addEventListener('scroll', this.checkViewport.bind(this))
    this.checkViewport()
  }

  checkViewport() {
    const charts = document.querySelectorAll('.highchart--loading')

    for (let i = 0; i < charts.length; i++) {
      const chart = charts[i]

      if (this.isVisible(chart) && !chart.classList.contains('loaded')) {
        window.requestAnimationFrame(() => {
          this.loadChart(chart)
        })
      }
    }
  }

  isVisible(element) {
    const distance = element.getBoundingClientRect()
    return (
      distance.top >= 0 &&
      distance.left >= 0 &&
      distance.bottom - distance.height * 0.2 <=
        (window.innerHeight || document.documentElement.clientHeight)
    )
  }

  loadChart(element) {
    const id = element.getAttribute('data-highchart')
    const script = document.createElement('script')
    element.classList.remove('highchart--loading')

    script.setAttribute('src', `https://cloud.highcharts.com/inject/${id}`)
    script.setAttribute('defer', 'defer')
    script.addEventListener('load', this.onChartLoad.bind(this, element))

    element.appendChild(script)
  }

  onChartLoad(element) {
    element.classList.add('loaded')
  }
}
